import { render, staticRenderFns } from "./MdmAssignModal.vue?vue&type=template&id=345a7ca0&lang=pug&"
import script from "./MdmAssignModal.vue?vue&type=script&lang=js&"
export * from "./MdmAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports